"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fileSaver = require("file-saver");
var _vuex = require("vuex");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _system = require("@/api/system");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AgreementGovernance',
  components: {
    Tinymce: _index.default
  },
  data: function data() {
    return {
      permissions: {
        create: 'platform:system:agreement:version:draft:create',
        update: 'platform:system:agreement:version:draft:update',
        notice: 'platform:system:agreement:version:notice',
        approve: 'platform:system:agreement:version:approve',
        publish: 'platform:system:agreement:version:publish',
        withdraw: 'platform:system:agreement:version:withdraw',
        history: 'platform:system:agreement:version:history',
        detail: 'platform:system:agreement:version:detail',
        download: 'platform:system:agreement:version:download',
        feedbackList: 'platform:system:agreement:feedback:list',
        feedbackDetail: 'platform:system:agreement:feedback:detail',
        feedbackDisposition: 'platform:system:agreement:feedback:disposition'
      },
      agreementTypes: [{
        title: '用户协议',
        type: 'userinfo',
        permissions: ['platform:system:agreement:user:info', 'platform:system:agreement:user:save']
      }, {
        title: '隐私协议',
        type: 'userprivacyinfo',
        permissions: ['platform:system:agreement:userprivacy:info', 'platform:system:agreement:userprivacy:save']
      }, {
        title: '入驻协议',
        type: 'merincomminginfo',
        permissions: ['platform:system:agreement:merincomming:info', 'platform:system:agreement:merincomming:save']
      }, {
        title: '关于我们',
        type: 'aboutusinfo',
        permissions: ['platform:system:agreement:aboutus:info', 'platform:system:agreement:aboutus:save']
      }, {
        title: '平台规则',
        type: 'platfromruleinfo',
        permissions: ['platform:system:agreement:platfromrule:info', 'platform:system:agreement:platfromrule:save']
      }, {
        title: '注销协议',
        type: 'useraccountcancelinfo',
        permissions: ['platform:system:agreement:useraccountcancel:info', 'platform:system:agreement:useraccountcancel:save']
      }, {
        title: '注销声明',
        type: 'useraccountcancelnoticeinfo',
        permissions: ['platform:system:agreement:useraccountcancelnotice:info', 'platform:system:agreement:useraccountcancelnotice:save']
      }],
      revisionKinds: [{
        value: 'MINOR',
        label: 'MINOR（小幅修订）',
        noticeDays: 7
      }, {
        value: 'MATERIAL',
        label: 'MATERIAL（重大修订）',
        noticeDays: 15
      }],
      feedbackDispositionOptions: [{
        value: 'PENDING',
        label: '待处理'
      }, {
        value: 'ACCEPTED',
        label: '已采纳'
      }, {
        value: 'REJECTED',
        label: '不采纳'
      }, {
        value: 'DUPLICATE',
        label: '重复反馈'
      }],
      pageSizes: [20, 40, 60, 80],
      activeType: '',
      actionError: '',
      historyLoading: false,
      historyRows: [],
      historyTotal: 0,
      historyQuery: {
        page: 1,
        size: 20
      },
      editorVisible: false,
      editorMode: 'create',
      editorKey: 0,
      versionLoading: false,
      saving: false,
      currentVersion: null,
      editorForm: {
        version: '',
        revisionKind: 'MINOR',
        content: '',
        changeSummary: ''
      },
      actionVersion: null,
      transitionSaving: false,
      noticeVisible: false,
      noticeForm: {
        noticeStartAt: null,
        noticeEndAt: ''
      },
      approveVisible: false,
      approveForm: {
        approvalRef: ''
      },
      publishVisible: false,
      publishForm: {
        effectiveAt: null
      },
      withdrawVisible: false,
      withdrawForm: {
        reason: ''
      },
      downloadingVersion: '',
      feedbackLoading: false,
      feedbackRows: [],
      feedbackTotal: 0,
      feedbackQuery: {
        page: 1,
        size: 20,
        type: '',
        version: '',
        disposition: ''
      },
      selectedFeedback: null,
      feedbackDetailVisible: false,
      feedbackDispositionVisible: false,
      feedbackDispositionSaving: false,
      feedbackDispositionForm: {
        id: null,
        disposition: '',
        note: ''
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['adminId'])), {}, {
    visibleAgreementTypes: function visibleAgreementTypes() {
      return this.agreementTypes.filter(function (item) {
        return (0, _permission.checkPermi)(item.permissions);
      });
    },
    isContentReadonly: function isContentReadonly() {
      return !!this.currentVersion && this.currentVersion.status !== 'DRAFT';
    },
    editorReadonly: function editorReadonly() {
      return this.editorMode === 'detail' || this.isContentReadonly;
    },
    revisionNoticeDays: function revisionNoticeDays() {
      return this.noticeDaysFor(this.editorForm.revisionKind);
    }
  }),
  created: function created() {
    if (this.visibleAgreementTypes.length) {
      this.activeType = this.visibleAgreementTypes[0].type;
      if (this.hasPermission('history')) this.loadHistory();
    }
    if (this.hasPermission('feedbackList')) this.loadFeedback();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    hasPermission: function hasPermission(action) {
      return (0, _permission.checkPermi)([this.permissions[action] || action]);
    },
    canUseAction: function canUseAction(action, version) {
      var actionsByStatus = {
        DRAFT: ['update', 'notice'],
        NOTICE: ['approve', 'publish', 'withdraw'],
        PUBLISHED: ['withdraw'],
        WITHDRAWN: []
      };
      var approvalComplete = !!(version && version.approvedBy != null && version.approvedAt && version.approvalRef && version.approvalRef.trim());
      return !!(version && actionsByStatus[version.status] && actionsByStatus[version.status].includes(action) && (action !== 'approve' || !approvalComplete) && (action !== 'publish' || approvalComplete && this.adminId !== version.approvedBy) && (0, _permission.checkPermi)([this.permissions[action]]));
    },
    agreementTypeLabel: function agreementTypeLabel(type) {
      var agreement = this.agreementTypes.find(function (item) {
        return item.type === type;
      });
      return agreement ? agreement.title : type || '-';
    },
    revisionKindLabel: function revisionKindLabel(kind) {
      var revision = this.revisionKinds.find(function (item) {
        return item.value === kind;
      });
      return revision ? revision.label : kind || '-';
    },
    noticeDaysFor: function noticeDaysFor(kind) {
      return kind === 'MINOR' ? 7 : kind === 'MATERIAL' ? 15 : 0;
    },
    statusLabel: function statusLabel(status) {
      return {
        DRAFT: '草稿',
        NOTICE: '公示中',
        PUBLISHED: '已发布',
        WITHDRAWN: '已撤回'
      }[status] || status || '-';
    },
    dispositionLabel: function dispositionLabel(disposition) {
      var option = this.feedbackDispositionOptions.find(function (item) {
        return item.value === disposition;
      });
      return option ? option.label : disposition || '-';
    },
    formatUtc: function formatUtc(value) {
      if (!value) return '-';
      var date = new Date(value);
      return Number.isNaN(date.getTime()) ? value : date.toISOString();
    },
    setActionError: function setActionError(error) {
      var responseData = error && error.response && error.response.data;
      var payload = responseData && _typeof(responseData) === 'object' ? responseData : error || {};
      var code = payload.code;
      var message = payload.message || (typeof payload === 'string' ? payload : '请求失败');
      this.actionError = code && String(code) !== message ? "".concat(code, ": ").concat(message) : message;
      if (this.$message && !payload.__requestMessageShown && !(error && error.__requestMessageShown)) {
        this.$message.error(this.actionError);
      }
    },
    handleTypeChange: function handleTypeChange() {
      this.historyQuery.page = 1;
      this.currentVersion = null;
      if (this.hasPermission('history')) this.loadHistory();
    },
    loadHistory: function () {
      var _loadHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var page, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.activeType) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.historyLoading = true;
              _context.p = 2;
              _context.n = 3;
              return (0, _system.agreementHistoryApi)(this.activeType, {
                page: this.historyQuery.page,
                size: this.historyQuery.size
              });
            case 3:
              page = _context.v;
              this.historyRows = page.list || [];
              this.historyTotal = Number(page.total) || 0;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.setActionError(_t);
            case 5:
              _context.p = 5;
              this.historyLoading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function loadHistory() {
        return _loadHistory.apply(this, arguments);
      }
      return loadHistory;
    }(),
    handleHistorySizeChange: function handleHistorySizeChange(size) {
      this.historyQuery.size = size;
      this.historyQuery.page = 1;
      this.loadHistory();
    },
    handleHistoryPageChange: function handleHistoryPageChange(page) {
      this.historyQuery.page = page;
      this.loadHistory();
    },
    openCreate: function openCreate() {
      this.actionError = '';
      this.currentVersion = null;
      this.editorMode = 'create';
      this.editorForm = {
        version: '',
        revisionKind: 'MINOR',
        content: '',
        changeSummary: ''
      };
      this.editorKey += 1;
      this.editorVisible = true;
    },
    viewVersion: function viewVersion(row) {
      return this.openVersion(row, 'detail');
    },
    editVersion: function editVersion(row) {
      return this.openVersion(row, 'edit');
    },
    openVersion: function () {
      var _openVersion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row, mode) {
        var version, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.actionError = '';
              this.versionLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _system.agreementVersionDetailApi)(this.activeType, row.version);
            case 2:
              version = _context2.v;
              this.editorMode = mode;
              this.applyVersion(version);
              this.editorVisible = true;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.setActionError(_t2);
            case 4:
              _context2.p = 4;
              this.versionLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function openVersion(_x, _x2) {
        return _openVersion.apply(this, arguments);
      }
      return openVersion;
    }(),
    applyVersion: function applyVersion(version) {
      this.currentVersion = version;
      this.editorForm = {
        version: version.version,
        revisionKind: version.revisionKind,
        content: version.content || '',
        changeSummary: version.changeSummary || ''
      };
      this.editorKey += 1;
    },
    saveDraft: function () {
      var _saveDraft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var creating, version, revisionKind, content, saved, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              creating = !this.currentVersion;
              version = (this.editorForm.version || '').trim();
              revisionKind = this.editorForm.revisionKind;
              content = this.editorForm.content || '';
              if (!(creating && !version || !['MINOR', 'MATERIAL'].includes(revisionKind) || !content.trim())) {
                _context3.n = 1;
                break;
              }
              this.$message.warning('请填写版本、修订类型和协议正文。');
              return _context3.a(2);
            case 1:
              this.saving = true;
              this.actionError = '';
              _context3.p = 2;
              if (!creating) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return (0, _system.agreementVersionCreateApi)(this.activeType, {
                version: version,
                revisionKind: revisionKind,
                content: content,
                changeSummary: this.editorForm.changeSummary || ''
              });
            case 3:
              saved = _context3.v;
              _context3.n = 6;
              break;
            case 4:
              _context3.n = 5;
              return (0, _system.agreementVersionUpdateApi)(this.activeType, this.currentVersion.version, {
                revisionKind: revisionKind,
                content: content,
                changeSummary: this.editorForm.changeSummary || '',
                rowVersion: this.currentVersion.rowVersion
              });
            case 5:
              saved = _context3.v;
            case 6:
              this.applyVersion(saved);
              this.editorVisible = false;
              this.$message.success('草稿已保存。');
              _context3.n = 7;
              return this.loadHistory();
            case 7:
              _context3.n = 9;
              break;
            case 8:
              _context3.p = 8;
              _t3 = _context3.v;
              // 保留 editorForm，冲突时不覆盖本地编辑内容。
              this.setActionError(_t3);
            case 9:
              _context3.p = 9;
              this.saving = false;
              return _context3.f(9);
            case 10:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 8, 9, 10]]);
      }));
      function saveDraft() {
        return _saveDraft.apply(this, arguments);
      }
      return saveDraft;
    }(),
    buildNoticePeriod: function buildNoticePeriod(start, revisionKind) {
      var noticeDays = revisionKind === 'MINOR' ? 7 : revisionKind === 'MATERIAL' ? 15 : 0;
      var startDate = new Date(start);
      if (!noticeDays || Number.isNaN(startDate.getTime())) throw new Error('公示开始时间或修订类型无效。');
      return {
        noticeStartAt: startDate.toISOString(),
        noticeEndAt: new Date(startDate.getTime() + noticeDays * 24 * 60 * 60 * 1000).toISOString()
      };
    },
    openNotice: function openNotice(row) {
      this.actionError = '';
      this.actionVersion = row;
      this.noticeForm = {
        noticeStartAt: null,
        noticeEndAt: ''
      };
      this.noticeVisible = true;
    },
    updateNoticeEnd: function updateNoticeEnd() {
      if (!this.noticeForm.noticeStartAt || !this.actionVersion) {
        this.noticeForm.noticeEndAt = '';
        return;
      }
      try {
        this.noticeForm.noticeEndAt = this.buildNoticePeriod(this.noticeForm.noticeStartAt, this.actionVersion.revisionKind).noticeEndAt;
      } catch (error) {
        this.noticeForm.noticeEndAt = '';
      }
    },
    submitNotice: function () {
      var _submitNotice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var period, version, _t4, _t5;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              period = this.buildNoticePeriod(this.noticeForm.noticeStartAt, this.actionVersion.revisionKind);
              _context4.n = 2;
              break;
            case 1:
              _context4.p = 1;
              _t4 = _context4.v;
              this.$message.warning(_t4.message);
              return _context4.a(2);
            case 2:
              if (!(new Date(period.noticeStartAt).getTime() < Date.now())) {
                _context4.n = 3;
                break;
              }
              this.$message.warning('公示开始时间不能早于当前时间。');
              return _context4.a(2);
            case 3:
              this.transitionSaving = true;
              this.actionError = '';
              _context4.p = 4;
              _context4.n = 5;
              return (0, _system.agreementNoticeApi)(this.activeType, this.actionVersion.version, {
                noticeStartAt: period.noticeStartAt,
                noticeEndAt: period.noticeEndAt,
                rowVersion: this.actionVersion.rowVersion
              });
            case 5:
              version = _context4.v;
              this.noticeVisible = false;
              this.$message.success('协议已进入公示期。');
              this.currentVersion = version;
              _context4.n = 6;
              return this.loadHistory();
            case 6:
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t5 = _context4.v;
              this.setActionError(_t5);
            case 8:
              _context4.p = 8;
              this.transitionSaving = false;
              return _context4.f(8);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[4, 7, 8, 9], [0, 1]]);
      }));
      function submitNotice() {
        return _submitNotice.apply(this, arguments);
      }
      return submitNotice;
    }(),
    openApprove: function openApprove(row) {
      this.actionError = '';
      this.actionVersion = row;
      this.approveForm.approvalRef = '';
      this.approveVisible = true;
    },
    submitApprove: function () {
      var _submitApprove = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var approvalRef, version, _t6;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              approvalRef = (this.approveForm.approvalRef || '').trim();
              if (approvalRef) {
                _context5.n = 1;
                break;
              }
              this.$message.warning('请输入审批依据 approvalRef。');
              return _context5.a(2);
            case 1:
              this.transitionSaving = true;
              this.actionError = '';
              _context5.p = 2;
              _context5.n = 3;
              return (0, _system.agreementApproveApi)(this.activeType, this.actionVersion.version, {
                approvalRef: approvalRef,
                rowVersion: this.actionVersion.rowVersion
              });
            case 3:
              version = _context5.v;
              this.approveVisible = false;
              this.$message.success('协议版本已审批。');
              this.currentVersion = version;
              _context5.n = 4;
              return this.loadHistory();
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t6 = _context5.v;
              this.setActionError(_t6);
            case 6:
              _context5.p = 6;
              this.transitionSaving = false;
              return _context5.f(6);
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 5, 6, 7]]);
      }));
      function submitApprove() {
        return _submitApprove.apply(this, arguments);
      }
      return submitApprove;
    }(),
    openPublish: function openPublish(row) {
      this.actionError = '';
      this.actionVersion = row;
      this.publishForm.effectiveAt = null;
      this.publishVisible = true;
    },
    submitPublish: function () {
      var _submitPublish = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var effectiveDate, noticeEnd, version, _t7;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              effectiveDate = new Date(this.publishForm.effectiveAt);
              if (!Number.isNaN(effectiveDate.getTime())) {
                _context6.n = 1;
                break;
              }
              this.$message.warning('请选择有效的生效时间。');
              return _context6.a(2);
            case 1:
              noticeEnd = new Date(this.actionVersion.noticeEndAt).getTime();
              if (!(effectiveDate.getTime() < Date.now() || !Number.isNaN(noticeEnd) && effectiveDate.getTime() < noticeEnd)) {
                _context6.n = 2;
                break;
              }
              this.$message.warning('生效时间不能早于当前时间或公示结束时间。');
              return _context6.a(2);
            case 2:
              this.transitionSaving = true;
              this.actionError = '';
              _context6.p = 3;
              _context6.n = 4;
              return (0, _system.agreementPublishApi)(this.activeType, this.actionVersion.version, {
                effectiveAt: effectiveDate.toISOString(),
                rowVersion: this.actionVersion.rowVersion
              });
            case 4:
              version = _context6.v;
              this.publishVisible = false;
              this.$message.success('协议版本已发布。');
              this.currentVersion = version;
              _context6.n = 5;
              return this.loadHistory();
            case 5:
              _context6.n = 7;
              break;
            case 6:
              _context6.p = 6;
              _t7 = _context6.v;
              this.setActionError(_t7);
            case 7:
              _context6.p = 7;
              this.transitionSaving = false;
              return _context6.f(7);
            case 8:
              return _context6.a(2);
          }
        }, _callee6, this, [[3, 6, 7, 8]]);
      }));
      function submitPublish() {
        return _submitPublish.apply(this, arguments);
      }
      return submitPublish;
    }(),
    openWithdraw: function openWithdraw(row) {
      this.actionError = '';
      this.actionVersion = row;
      this.withdrawForm.reason = '';
      this.withdrawVisible = true;
    },
    submitWithdraw: function () {
      var _submitWithdraw = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var reason, version, _t8;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              reason = (this.withdrawForm.reason || '').trim();
              if (reason) {
                _context7.n = 1;
                break;
              }
              this.$message.warning('请输入撤回原因。');
              return _context7.a(2);
            case 1:
              this.transitionSaving = true;
              this.actionError = '';
              _context7.p = 2;
              _context7.n = 3;
              return (0, _system.agreementWithdrawApi)(this.activeType, this.actionVersion.version, {
                reason: reason,
                rowVersion: this.actionVersion.rowVersion
              });
            case 3:
              version = _context7.v;
              this.withdrawVisible = false;
              this.$message.success('协议版本已撤回。');
              this.currentVersion = version;
              _context7.n = 4;
              return this.loadHistory();
            case 4:
              _context7.n = 6;
              break;
            case 5:
              _context7.p = 5;
              _t8 = _context7.v;
              this.setActionError(_t8);
            case 6:
              _context7.p = 6;
              this.transitionSaving = false;
              return _context7.f(6);
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 5, 6, 7]]);
      }));
      function submitWithdraw() {
        return _submitWithdraw.apply(this, arguments);
      }
      return submitWithdraw;
    }(),
    getDownloadFileName: function getDownloadFileName(contentDisposition, fallback) {
      var header = contentDisposition || '';
      var encoded = header.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);
      var plain = header.match(/filename\s*=\s*"([^"]+)"/i) || header.match(/filename\s*=\s*([^;]+)/i);
      var fileName = encoded ? encoded[1] : plain ? plain[1] : fallback;
      fileName = fileName.trim().replace(/^"|"$/g, '');
      try {
        fileName = decodeURIComponent(fileName);
      } catch (error) {
        // Content-Disposition 不是合法百分号编码时保留服务端原始文件名。
      }
      return fileName.split(/[\\/]/).pop() || fallback;
    },
    downloadVersion: function () {
      var _downloadVersion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(row) {
        var response, headers, contentTypeHeader, mediaType, blob, _t9;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              this.downloadingVersion = row.version;
              this.actionError = '';
              _context8.p = 1;
              _context8.n = 2;
              return (0, _system.agreementVersionDownloadApi)(this.activeType, row.version);
            case 2:
              response = _context8.v;
              headers = response.headers || {};
              contentTypeHeader = headers['content-type'] || response.data.type || 'application/octet-stream';
              mediaType = contentTypeHeader.split(';')[0].trim();
              blob = response.data instanceof Blob && response.data.type === mediaType ? response.data : new Blob([response.data], {
                type: mediaType
              });
              (0, _fileSaver.saveAs)(blob, this.getDownloadFileName(headers['content-disposition'], "".concat(this.activeType, "-").concat(row.version, ".html")));
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t9 = _context8.v;
              this.setActionError(_t9);
            case 4:
              _context8.p = 4;
              this.downloadingVersion = '';
              return _context8.f(4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3, 4, 5]]);
      }));
      function downloadVersion(_x3) {
        return _downloadVersion.apply(this, arguments);
      }
      return downloadVersion;
    }(),
    loadFeedback: function () {
      var _loadFeedback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var page, _t0;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              this.feedbackLoading = true;
              _context9.p = 1;
              _context9.n = 2;
              return (0, _system.agreementFeedbackListApi)({
                page: this.feedbackQuery.page,
                size: this.feedbackQuery.size,
                type: this.feedbackQuery.type,
                version: this.feedbackQuery.version,
                disposition: this.feedbackQuery.disposition
              });
            case 2:
              page = _context9.v;
              this.feedbackRows = page.list || [];
              this.feedbackTotal = Number(page.total) || 0;
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t0 = _context9.v;
              this.setActionError(_t0);
            case 4:
              _context9.p = 4;
              this.feedbackLoading = false;
              return _context9.f(4);
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 3, 4, 5]]);
      }));
      function loadFeedback() {
        return _loadFeedback.apply(this, arguments);
      }
      return loadFeedback;
    }(),
    searchFeedback: function searchFeedback() {
      this.feedbackQuery.page = 1;
      this.loadFeedback();
    },
    resetFeedback: function resetFeedback() {
      this.feedbackQuery = {
        page: 1,
        size: 20,
        type: '',
        version: '',
        disposition: ''
      };
      this.loadFeedback();
    },
    handleFeedbackSizeChange: function handleFeedbackSizeChange(size) {
      this.feedbackQuery.size = size;
      this.feedbackQuery.page = 1;
      this.loadFeedback();
    },
    handleFeedbackPageChange: function handleFeedbackPageChange(page) {
      this.feedbackQuery.page = page;
      this.loadFeedback();
    },
    openFeedbackDetail: function () {
      var _openFeedbackDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(id) {
        var _t1;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              this.actionError = '';
              _context0.p = 1;
              _context0.n = 2;
              return (0, _system.agreementFeedbackDetailApi)(id);
            case 2:
              this.selectedFeedback = _context0.v;
              this.feedbackDetailVisible = true;
              _context0.n = 4;
              break;
            case 3:
              _context0.p = 3;
              _t1 = _context0.v;
              this.setActionError(_t1);
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this, [[1, 3]]);
      }));
      function openFeedbackDetail(_x4) {
        return _openFeedbackDetail.apply(this, arguments);
      }
      return openFeedbackDetail;
    }(),
    openFeedbackDisposition: function openFeedbackDisposition(row) {
      this.actionError = '';
      this.feedbackDispositionForm = {
        id: row.id,
        disposition: row.disposition === 'PENDING' ? '' : row.disposition,
        note: row.dispositionNote || ''
      };
      this.feedbackDispositionVisible = true;
    },
    submitFeedbackDisposition: function () {
      var _submitFeedbackDisposition = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var disposition, _t10;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              disposition = this.feedbackDispositionForm.disposition;
              if (['ACCEPTED', 'REJECTED', 'DUPLICATE'].includes(disposition)) {
                _context1.n = 1;
                break;
              }
              this.$message.warning('请选择有效的处置结果。');
              return _context1.a(2);
            case 1:
              this.feedbackDispositionSaving = true;
              this.actionError = '';
              _context1.p = 2;
              _context1.n = 3;
              return (0, _system.agreementFeedbackDispositionApi)(this.feedbackDispositionForm.id, {
                disposition: disposition,
                note: this.feedbackDispositionForm.note || ''
              });
            case 3:
              this.feedbackDispositionVisible = false;
              this.$message.success('反馈已处置。');
              _context1.n = 4;
              return this.loadFeedback();
            case 4:
              _context1.n = 6;
              break;
            case 5:
              _context1.p = 5;
              _t10 = _context1.v;
              this.setActionError(_t10);
            case 6:
              _context1.p = 6;
              this.feedbackDispositionSaving = false;
              return _context1.f(6);
            case 7:
              return _context1.a(2);
          }
        }, _callee1, this, [[2, 5, 6, 7]]);
      }));
      function submitFeedbackDisposition() {
        return _submitFeedbackDisposition.apply(this, arguments);
      }
      return submitFeedbackDisposition;
    }()
  }
};